//Reset data
export const RESET = "TICKET_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "TICKET_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "TICKET_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "TICKET_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "TICKET_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "TICKET_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "TICKET_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "TICKET_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "TICKET_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "TICKET_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "TICKET_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "TICKET_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "TICKET_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "TICKET_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "TICKET_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "TICKET_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "TICKET_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "TICKET_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "TICKET_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "TICKET_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "TICKET_DEL_SET_IS_UPDATE"